/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_FootnoteInputs */

const en_mk_mx_footnote = /** @type {(inputs: Mk_Mx_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A seat is a person. Agents are never counted as billable seats, in line with what is now standard practice. A crossed-out row does not mean “coming soon” — where we have not built something, we say so plainly on the Security & data page.`)
};

const id_mk_mx_footnote = /** @type {(inputs: Mk_Mx_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursi = manusia. Agen tidak pernah dihitung sebagai kursi berbayar, sesuai praktik yang kini umum di industri. Baris yang bertanda silang bukan berarti "segera hadir" — kalau kami belum membangunnya, kami menuliskannya apa adanya di halaman Keamanan & data.`)
};

/**
* | output |
* | --- |
* | "A seat is a person. Agents are never counted as billable seats, in line with what is now standard practice. A crossed-out row does not mean “coming soon” — w..." |
*
* @param {Mk_Mx_FootnoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_footnote = /** @type {((inputs?: Mk_Mx_FootnoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_FootnoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_footnote(inputs)
	return en_mk_mx_footnote(inputs)
});